import "./new-hco.css";
import NewRelation from "../detail-page/input/relation";
import { Add } from "@mui/icons-material";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  IconButton,
  Tooltip,
  DialogActions,
  Button,
  Stack,
  Card,
  CardContent,
  Alert,
} from "@mui/material";
import IdentifiersView from "../detail-page/input/identifiers-view";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState, useEffect, useContext } from "react";
import InputDetailsHCO from "../detail-page/input/detail-input-newHCO";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CONSTANT from "../../Constant/Constant";
import api from "../../service/api";
import filter from "../../service/filter";
import ProgressBar from "../progress/progressBar";
import ErrorPage from "../error-page/error";
import Storage from "../../session/storage";
import moment from "moment";
import jsondata from "../../config/NewHCOFormFields.json";
import { useLocation, withRouter } from "react-router-dom";
import popUpMessage from "../../config/popUpMsg.json";
import payloadCountry from "../../config/vendorPicklistApiPayload.json";
import { DirectionContext } from "../../context/DirectionProvider";
import EditIcon from "@mui/icons-material/Edit";
import ConfirmationDialogRaw1 from "../globalSearch/popupGlobal";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import LillySources from "../../config/ProfileDetailsData.json";
import PopupConfimation from "./PopupConfirmation";
import useLocalStorage from "../../hooks/useLocalStorage";

const AddNewHCO = (props) => {
  const location = useLocation();
  const lillyManagedBrickDefaults = {
    BRICK: [{
      [CONSTANT.BRICK_FIELDS.BRICK_TYPE]: [{ value: 'BRK', lookupRawValue: 'BRK' }],
      [CONSTANT.BRICK_FIELDS.BRICK_ID]: [{ value: '' }],
      [CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_START_DATE]: [{ value: moment.utc(new Date()).format("YYYY-MM-DD") }],
      [CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_END_DATE]: [{ value: "9999-12-31" }],
      [CONSTANT.BRICK_FIELDS.BRICK_SOURCE]: [{ value: 'LLY-MNGD' }],
    }],
  };
  const [accordianFlag, changeAccordianFlag] = useState({
    mainInfo: true,
    speciality: true,
    Relation: true,
    Address: true,
    BRICK: false,
    Identifiers: true,
    contactData: true,
  });
  const [modal, setModal] = useState({ flag: false });
  const [error, setError] = useState(false);
  const [relationError, setRelationError] = useState(false);
  const [HCORequest, setHCORequest] = useState(CONSTANT.NEW_HCO_BODY);
  const [validRequest, setValidRequest] = useState({});
  const [optionalRelation, setOptionalRelation] = useState("Not Set");
  const [clear, setClear] = useState(false);
  const [address, setAddress] = useState(false);
  const [showRelation, setShowRelation] = useState(false);
  const [showSpeciality, setShowSpeciality] = useState(false);
  const [showSpecialityAccordian, setShowSpecialityAccordian] = useState(false);
  const [showError] = useState(false);
  const [changeCompleted] = useState();
  const [loading, setLoading] = useState(true);
    // const [lillySelectedCountry, setLillySelectedCountry] = useState([]);
  // const [lillySelectedCountrysource, setLillySelectedCountrySource] = useState(
  //   []
  // );
  const [showModal, setShowModal] = useState(true);
  const [errorMsg, setErrorMsg] = useState();
  const [data] = useState(jsondata);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [filterdata, setfilterdata] = useState();
  const [iqviaEnnable, setIqviaEnnable] = useState(false);
  const [popMsg] = useState(popUpMessage.newHCO);
  const [identifierSubmit, setIdentifierSubmit] = useState(false);
  const [noIdentifierData, setNoIdentifierData] = useState(false);
  const direction = useContext(DirectionContext);
  const [allCountry, setAllCountry] = useState("");
  const [closeSpecialtyPopup, setCloseSpecialtyPopup] = useState(false);
  const [newSource, setNewSource] = useState("");
  const [selectedSpecialty] = useState({});
  const [showAllData, setShowAllData] = useState(false);
  const [userData] = useState(location.state.user);
  const [originalSource, setOriginalSource] = useState("");
  const [langLocaleChange] = useLocalStorage('wglang_api');

  useEffect(() => {
    if (location.state.iqviaSource || location.state.homePage_Lilly) {
      handleFunction();
    }
  }, [langLocaleChange]);

  var getPaylodCountry = payloadCountry.countries.find(
    (res) => res.country_Name === location.state.country
  );
  var getdata;
  var requirefields = [];

  useEffect(() => {
    if (
      location?.state?.iqviaSource == undefined ||
      location?.state?.iqviaSource == null ||
      location.state.homePage_Lilly == undefined ||
      location.state.homePage_Lilly == null
    ) {
      props.history.push("/");
    } else {
      setLoading(true);
      setIqviaEnnable(location.state.iqviaSource);
      async function fetchDetails() {
        await api
          .getSelectedDCRCountry()
          .then((countryList) => {
            Storage.setAllCountryList(countryList.data)
            var countryListData = countryList.data.filter((arr) => {
              return !arr.includes("#");
            });
            setAllCountry(countryList.data);
            // setLillySelectedCountry(
             //   countryListData.map((el) => {
            //     return el.split("#")[0];
            //   })
            // );
            // setLillySelectedCountrySource(countryList.data);
            setTimeout(() => {
              setLoading(false);
            }, 4000);
          })
          .catch((error) => {
            let errorDetail = error;
            let msg = errorDetail.response
              ? errorDetail.response.data.errorCode
              : "Internal Server Error!";
            setErrorMsg(msg ? msg : "Internal Server Error!");
            setLoading(false);
          });
      }

      fetchDetails();

      if (location.state.iqviaSource || location.state.homePage_Lilly) {
        handleFunction();
      }
      // if(!jsondata.allow_override_dcr){
      //   changeSourceAndFields()
      // }
    }
  }, [
    location.state.country,
    location.state.source,
    location.state.newSpecialty,
  ]);

  // Fetching country data for displaying input field of Iqvia country
  const countryDataFetch = (newSource) => {
    getdata = data.countries.find((el) => {
      if (el.country_Name == location.state.country) {
        return el.country_Name === location.state.country;
      } else {
        return el.country_Name == "default";
      }
    });

    setfilterdata(
      (newSource == "VNDR-CGDM" || location.state.source == "VNDR-CGDM") ? getdata.input.iqvia :
      (newSource == "VNDR-VOD" ? getdata.input.openData : getdata.input.eph)
    );
    setSelectedCountry(
      location.state.country ? location.state.country : selectedCountry
    );
  };

  // handle function for handling body of iqvia input field
  const handleFunction = () => {
    let receivedResponse;
    setLoading(true);

    api
      .getPickList(
        getPaylodCountry
          ? getPaylodCountry.key.payloadKey
          : location.state.country,
        jsondata.allow_override_dcr ? undefined : "MNGD-AFF",
        undefined,
        "HCO",
        jsondata.allow_override_dcr ? true : undefined,
        langLocaleChange
      )
      .then((res) => {
        Storage.setLovBoundedList(filter.mapPickList(res.data[0]));
        setNewSource(res.data[0]["source"][0]);
        countryDataFetch(res.data[0]["source"][0]);
        setOriginalSource(res.data[0]["source"][0]);
        receivedResponse = res.data[0]["source"][0];
        setShowModal(false);
        setLoading(false);
        setShowAllData(true);

        // check if specility are there

        if ((res.data[0]["HCO"] && res.data[0]["HCO"]?.spclty?.length > 0) || (res.data[0]["UNCLASSIFIED"] && res.data[0]["UNCLASSIFIED"]?.spclty?.length > 0)) {
          setShowSpecialityAccordian(true)
        } else {
          setShowSpecialityAccordian(false)
        }
      })
      .catch((error) => {
        let errorDetail = error;
        let msg = errorDetail.response
          ? errorDetail.response.data.errorCode
          : "Internal Server Error!";
        setErrorMsg(msg ? msg : "Internal Server Error!");
        setLoading(false);
      });

    if (location.state.homePage_Lilly && receivedResponse === "VNDR-CGDM") {
      setHCORequest({
        entity: {
          type: "configuration/entityTypes/HCO",
          ActiveFlag: [{ value: "Y" }],
          EffectiveStartDate: [
            { value: moment.utc(new Date()).format("YYYY-MM-DD") },
          ],
          EffectiveEndDate: [{ value: "9999-12-31" }],
          NewSpecialities: location.state.newSpecialty,
          NewIdentifiers: [],
          Address: [
            {
              Country: [{ value: selectedCountry }],
              ActiveFlag: [{ value: "Y" }],
            },
          ],
          Source: [{ value: newSource }],
        },
        relations: [],
        RequestTo: location.state.vendor,
        vendor: location.state.vendor,
      });
    } else if (location.state.homePage_Lilly && receivedResponse !== "VNDR-CGDM") {
      setHCORequest({
        entity: {
          type: "configuration/entityTypes/HCO",
          ActiveFlag: [{ value: "Y" }],
          EffectiveStartDate: [
            { value: moment.utc(new Date()).format("YYYY-MM-DD") },
          ],
          EffectiveEndDate: [{ value: "9999-12-31" }],
          NewSpecialities: location.state.newSpecialty,
          NewIdentifiers: [],
          Address: [
            {
              Country: [{ value: selectedCountry }],
              ActiveFlag: [{ value: "Y" }],
              ...lillyManagedBrickDefaults,
            },
          ],
          Source: [{ value: newSource }],
        },
        relations: [],
      });
    } else {
      setHCORequest({
        entity: {
          type: "configuration/entityTypes/HCO",
          ActiveFlag: [{ value: "Y" }],
          EffectiveStartDate: [
            { value: moment.utc(new Date()).format("YYYY-MM-DD") },
          ],
          EffectiveEndDate: [{ value: "9999-12-31" }],
          NewSpecialities: undefined,
          NewIdentifiers: [],
          Address: [
            {
              Country: [{ value: selectedCountry }],
              ActiveFlag: [{ value: "Y" }],
              ...lillyManagedBrickDefaults,
            },
          ],
          Source: [{ value: newSource }],
        },
        relations: [],
        RequestTo: location.state.vendor,
        vendor: location.state.vendor,
      });
    }
    var value = location.state.country;
    updateValue({ value }, false, "CountryCode");
    window.scroll(0, 0);
  };

  useEffect(() => {
    if (!iqviaEnnable) {
      if (newSource === "VNDR-CGDM") {
        setHCORequest({
          entity: {
            type: "configuration/entityTypes/HCO",
            ActiveFlag: [{ value: "Y" }],
            EffectiveStartDate: [
              { value: moment.utc(new Date()).format("YYYY-MM-DD") },
            ],
            EffectiveEndDate: [{ value: "9999-12-31" }],
            NewSpecialities: location.state.newSpecialty
              ? location.state.newSpecialty
              : selectedSpecialty,
            NewIdentifiers: [],
            Address: [
              {
                Country: [{ value: selectedCountry }],
                ActiveFlag: [{ value: "Y" }],
              },
            ],
            Source: [{ value: newSource }],
          },
          relations: [],
          RequestTo: location.state.vendor ? location.state.vendor : "IQVIA",
          vendor: location.state.vendor ? location.state.vendor : "IQVIA",
        });
      } else {
        setHCORequest({
          entity: {
            type: "configuration/entityTypes/HCO",
            ActiveFlag: [{ value: "Y" }],
            EffectiveStartDate: [
              { value: moment.utc(new Date()).format("YYYY-MM-DD") },
            ],
            EffectiveEndDate: [{ value: "9999-12-31" }],
            NewSpecialities: location.state.newSpecialty
              ? location.state.newSpecialty
              : selectedSpecialty,
            NewIdentifiers: [],
            Address: [
              {
                Country: [{ value: selectedCountry }],
                ActiveFlag: [{ value: "Y" }],
                ...lillyManagedBrickDefaults,
              },
            ],
            Source: [{ value: newSource }],
          },
          relations: [],
        });
      }
    }

    var value = location.state.country
      ? location.state.country
      : selectedCountry;
    updateValue({ value }, false, "CountryCode");
  }, [
    newSource,
    location.state.country,
    location.state.newSpecialty,
    selectedCountry,
    selectedSpecialty,
  ]);

  // Ensure BRICK defaults are present on the Address if source is Lilly-managed
  useEffect(() => {
    try {
      const isLilly = CONSTANT.BRICK_LILLY_MANAGED_SOURCES.includes(HCORequest?.entity?.Source?.[0]?.value);
      const addr = HCORequest?.entity?.Address?.[0];
      if (isLilly && addr && !addr.BRICK) {
        setHCORequest((old) => ({
          ...old,
          entity: {
            ...old.entity,
            Address: [
              {
                ...addr,
                ...(lillyManagedBrickDefaults.BRICK ? { BRICK: lillyManagedBrickDefaults.BRICK } : {}),
              },
            ],
          },
        }));
      }
    } catch (e) {
      // ignore
    }
  }, [HCORequest?.entity?.Address, HCORequest?.entity?.Source]);

  // Accordian close
  const closeAccordian = (id) => {
    changeAccordianFlag({
      ...accordianFlag,
      [id]: !accordianFlag[id],
    });
  };

  /**
   * Back to home
   */
  const goBack = () => {
    props.history.push("/");
  };

  const editCountry = () => {
    if (location.state.homePage_Lilly) {
      setCloseSpecialtyPopup(true);
    }

    if (!location.state.homePage_Lilly && !iqviaEnnable) {
      setShowModal(true);
    }
  };

  /**
   * Update all values
   */
  const updateValue = (newValue, flag, attribute) => {
    if (
      !!newValue &&
      attribute != "Relation" &&
      attribute != "Identifiers" &&
      attribute != "OtherSpecialty"
    ) {
      Object.keys(newValue).forEach((k) => {
        if (typeof newValue[k] === "string") newValue[k] = newValue[k].trim();
      });
    }

    if (attribute === "CountryCode") {
      if (
        newValue.value !== null &&
        !CONSTANT.HCP_RELATION.includes(newValue.value)
      ) {
        setOptionalRelation("Optional");
        setAddress(false);
        setShowRelation(false);
        setShowSpeciality(false);
      } else if (
        newValue.value !== null &&
        CONSTANT.HCP_RELATION.includes(newValue.value)
      ) {
        setOptionalRelation("Optional");
        setRelationError(false);
        setAddress(true);
        setShowRelation(false);
      } else {
        setOptionalRelation("Not Set");
        setHCORequest((oldvalue) => ({
          ...oldvalue,
          entity: {
            ...oldvalue.entity,
            Address: undefined,
          },
        }));
        setAddress(false);
        setShowRelation(false);
        delete HCORequest.relations;
        delete HCORequest.entity.Address;
      }
    }

    if (attribute !== "Relation") {
      if (CONSTANT.SPECIALITY_TYPE.includes(attribute)) {
        setHCORequest((oldvalue) => ({
          ...oldvalue,
          entity: {
            ...oldvalue.entity,
            NewSpecialities: {
              ...oldvalue.entity.NewSpecialities,
              [attribute]: [newValue],
            },
          },
        }));
      } else if (attribute === "Identifiers") {
        if (HCORequest && HCORequest["entity"]) {
          setHCORequest((oldValue) => ({
            ...oldValue,
            entity: {
              ...oldValue.entity,
              NewIdentifiers: newValue,
            },
          }));
        }
      } else if (
        attribute === CONSTANT.BRICK_FIELDS.BRICK_TYPE ||
        attribute === CONSTANT.BRICK_FIELDS.BRICK_ID ||
        attribute === CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_START_DATE ||
        attribute === CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_END_DATE ||
        attribute === CONSTANT.BRICK_FIELDS.BRICK_SOURCE
      ) {
        setHCORequest((oldvalue) => ({
          ...oldvalue,
          entity: {
            ...oldvalue.entity,
            Address: [
              {
                ...oldvalue.entity.Address?.[0],
                BRICK: [{
                  ...oldvalue.entity.Address?.[0]?.BRICK?.[0],
                  [attribute]: [newValue],
                }],
              },
            ],
          },
        }));
      } else if (CONSTANT.ADDRESS_ATTRIBUTE.includes(attribute)) {
        if (HCORequest.entity.Address !== undefined) {
          if (attribute === "StateProvince") {
            setHCORequest((oldvalue) => ({
              ...oldvalue,
              entity: {
                ...oldvalue.entity,
                Address: [
                  {
                    ...oldvalue.entity.Address[0],
                    [attribute]: [newValue],
                    Rank: [{ value: "1" }],
                    EffectiveStartDate: [
                      { value: moment.utc(new Date()).format("YYYY-MM-DD") },
                    ],
                    EffectiveEndDate: [{ value: "9999-12-31" }],
                  },
                ],
              },
            }));
          } else {
            setHCORequest((oldvalue) => ({
              ...oldvalue,
              entity: {
                ...oldvalue.entity,
                Address: [
                  {
                    ...oldvalue.entity.Address[0],
                    [attribute]: [newValue],
                  },
                ],
              },
            }));
          }
        } else {
          setHCORequest((oldvalue) => ({
            ...oldvalue,
            entity: {
              ...oldvalue.entity,
              Address: [
                {
                  [attribute.split(".")[1]]: [newValue],
                },
              ],
            },
          }));
        }
      } else {
        if (attribute.split(".")[0] === "Address") {
          if (HCORequest.entity.Address !== undefined) {
            setHCORequest((oldvalue) => ({
              ...oldvalue,
              entity: {
                ...oldvalue.entity,
                Address: [
                  {
                    ...oldvalue.entity.Address[0],
                    [attribute.split(".")[1]]: [newValue],
                    Rank: [{ value: "1" }],
                    EffectiveStartDate: [
                      { value: moment.utc(new Date()).format("YYYY-MM-DD") },
                    ],
                    EffectiveEndDate: [{ value: "9999-12-31" }],
                  },
                ],
              },
            }));
          } else {
            setHCORequest((oldvalue) => ({
              ...oldvalue,
              entity: {
                ...oldvalue.entity,
                Address: [
                  {
                    [attribute.split(".")[1]]: [newValue],
                  },
                ],
              },
            }));
          }
        } else {
          setHCORequest((oldvalue) => ({
            ...oldvalue,
            entity: {
              ...oldvalue.entity,
              [attribute]: [newValue],
            },
          }));
        }
      }
    } else {
      if (newValue === undefined) {
        setHCORequest((oldValue) => {
          return {
            ...oldValue,
            relations: [],
          };
        });
      } else {
        if (newValue.Country === undefined) {
          setHCORequest((oldValue) => ({
            ...oldValue,
            relations: [
              {
                uri: newValue?.HCO?._id,
                type: newValue?.HCO?._source?.type,
                label: newValue?.HCO?._source?.label,
                EffectiveStartDate: [
                  { value: moment.utc(new Date()).format("YYYY-MM-DD") },
                ],
                EffectiveEndDate: [{ value: "9999-12-31" }],
                Rank: newValue.Rank ? newValue.Rank : [{ value: "99" }],
                Source: newValue?.HCO?._source?.Source,
                DepartmentIndicator: newValue?.HCO?._source?.DepartmentIndicator,
                IsNew: true,
                IsPrimary: newValue.Rank && newValue.Rank[0].value == 1,
                IsParent:
                  newValue?.HCO?._source?.DepartmentIndicator &&
                  newValue?.HCO?._source?.DepartmentIndicator[0]?.value === 'Y'
                    ? false
                    : newValue.Parent
                    ? newValue.Parent[0].value
                    : undefined,
                relationTypeCode: newValue.Affiliations
                  ? newValue?.Affiliations[0].value
                  : undefined,
              },
            ],
          }));
        } else {
          const { AddressLine1, City, Zip, StateProvince, Country, ClassificationCode } = newValue;
          setHCORequest((oldValue) => ({
            ...oldValue,
            relations: [
              {
                Country,
                ClassificationCode,
                Name: newValue.HCO,
                ActiveFlag: [{ value: "Y" }],
                Address: [
                  {
                    AddressLine1,
                    City,
                    Zip,
                    StateProvince,
                    Country,
                    EffectiveStartDate: [
                      { value: moment.utc(new Date()).format("YYYY-MM-DD") },
                    ],
                    EffectiveEndDate: [{ value: "9999-12-31" }],
                    Rank: [{ value: "1" }],
                  },
                ],
                EffectiveStartDate: [
                  { value: moment.utc(new Date()).format("YYYY-MM-DD") },
                ],
                EffectiveEndDate: [{ value: "9999-12-31" }],
                Rank: newValue.Rank ? newValue.Rank : [{ value: "99" }],
                IsNew: true,
                Source: [{ value: newSource }],
                IsParent:
                  newValue?.HCO?._source?.DepartmentIndicator &&
                  newValue?.HCO?._source?.DepartmentIndicator[0]?.value === 'Y'
                    ? undefined
                    : newValue.Parent
                    ? newValue.Parent[0].value
                    : undefined,
                relationTypeCode: newValue.Affiliations
                  ? newValue?.Affiliations[0].value
                  : undefined,
                IsPrimary: newValue.Rank && newValue.Rank[0].value == 1,
              },
            ],
          }));
        }
      }
    }

    if (attribute.split(".")[0] === "Address") {
      let allAddressFlag = false;
      const isLillyManaged = CONSTANT.BRICK_LILLY_MANAGED_SOURCES.includes(HCORequest?.entity?.Source?.[0]?.value);
      const fieldsToCheck = CONSTANT.ADDRESS_ATTRIBUTE.filter(f => f !== 'BRICK' || isLillyManaged);
      fieldsToCheck.forEach((value) => {
        let addresValue = HCORequest.entity.Address
          ? HCORequest.entity.Address[0]
          : undefined;
        if (attribute.split(".")[1] !== value) {
          allAddressFlag =
            allAddressFlag ||
            !(
              addresValue &&
              addresValue[value] !== undefined &&
              addresValue[value][0].value.length !== 0
            );
        } else {
          allAddressFlag = allAddressFlag || !(newValue.value.length !== 0);
        }
      });
      setValidRequest((old) => ({
        ...old,
        Address: allAddressFlag,
      }));
    } else {
      setValidRequest((old) => ({
        ...old,
        [attribute]: flag,
      }));
    }
  };

  const checkIdentifierSubmitted = (
    addflag,
    identifierType,
    identifierId,
    identifierSaved
  ) => {
    if (
      addflag &&
      ((identifierType?.length == 0 && identifierId?.length == 0) ||
        (identifierType == undefined && identifierId == undefined)) &&
      identifierSaved == false
    ) {
      setNoIdentifierData(true);
      setIdentifierSubmit(false);
    } else if (
      addflag &&
      identifierType?.length > 0 &&
      identifierId?.length > 0 &&
      identifierSaved == false
    ) {
      setIdentifierSubmit(true);
      setNoIdentifierData(false);
    } else {
      setIdentifierSubmit(false);
      setNoIdentifierData(false);
    }
  };

  /**
   * Function to validate HCO address
   */
  const validateAddress = (address) => {
    if (!address || address.length === 0) return false;

    const addr = address[0];
    // Check only core address fields that should always be present
    const coreFields = ['AddressLine1', 'City', 'Zip', 'StateProvince', 'Country'];

    const allFieldsValid = coreFields.every((field) => {
      const fieldData = addr[field];
      if (!fieldData || !Array.isArray(fieldData) || fieldData.length === 0) {
        return false;
      }
      const value = fieldData[0] && fieldData[0].value;
      return value && value.toString().trim().length > 0;
    });

    return allFieldsValid;
  };

  /**
   * Return list of missing address attributes for clearer error reporting
   */
  const getMissingAddressAttributes = (address) => {
    const missing = [];
    if (!address || address.length === 0) return ['Address'];
    const addr = address[0];
    const isLillyManaged = LillySources.LILLY_MANAGED_SOURCES.includes(newSource);

    // For Lilly-managed sources, check BRICK if accordion is open
    if (isLillyManaged && accordianFlag['BRICK']) {
      const brick = addr.BRICK && addr.BRICK[0];
      if (!brick) {
        missing.push('BRICK');
      } else {
        const idField = brick[CONSTANT.BRICK_FIELDS.BRICK_ID];
        const idValue = idField && idField[0] && idField[0].value;
        if (!idValue || idValue.toString().trim().length === 0) missing.push('BrickId');
      }
    }
    return missing;
  };

  /**
   * Submit New HCO Request
   */
  const submitRequest = () => {
    let isValid = true;
    if (HCORequest === undefined || validRequest === undefined) {
      setError(true);
      setModal(true);
    } else if (noIdentifierData) {
      setModal({
        flag: true,
        success: false,
        message: "Please enter data into the Identifier fields before Submitting Request !",
        title: "Error",
      });
    } else if (identifierSubmit) {
      setModal({
        flag: true,
        success: false,
        message: "Please save the identifiers before submitting the request",
        title: "Error",
      });
    } else {
      let errorFlag = false;
      if (
        HCORequest?.entity?.Address?.length === 0 ||
        !validateAddress(HCORequest?.entity?.Address)
      ) {
        errorFlag = true;
        isValid = false;
      } else if (
        optionalRelation !== "Optional" &&
        !HCORequest?.relations[0]?.relationTypeCode
      ) {
        errorFlag = true;
        isValid = false;
      } else if (
        optionalRelation === "Optional" &&
        newSource != 'VNDR-VOD' &&
        HCORequest?.relations?.length > 0 &&
        !HCORequest?.relations[0]?.relationTypeCode
      ) {
        errorFlag = true;
        isValid = false;
      }

      // Check BRICK if Lilly-managed and accordion is open
      const isLillyManaged = LillySources.LILLY_MANAGED_SOURCES.includes(newSource);
      if (isLillyManaged && accordianFlag['BRICK']) {
        const brick = HCORequest?.entity?.Address?.[0]?.BRICK?.[0];
        if (brick) {
          const idField = brick?.[CONSTANT.BRICK_FIELDS.BRICK_ID];
          const idValue = idField?.[0]?.value;
          if (!idValue || idValue.toString().trim().length === 0) {
            errorFlag = true;
            isValid = false;
          }
        } else {
          // BRICK accordion is open but no brick data
          errorFlag = true;
          isValid = false;
        }
      }

      if (!errorFlag) {
        requirefields.forEach((id) => {
          let value = validRequest[id];
          if (id === "Relation" && !showRelation) {
            errorFlag = errorFlag || false;
            setRelationError(false);
          } else if (id === "Address" && !address) {
            errorFlag = errorFlag || false;
            setRelationError(false);
          } else if (
            validRequest["Relation"] === undefined ||
            validRequest["Relation"] === true
          ) {
            if (showRelation) {
              errorFlag = errorFlag || true;
              setRelationError(true);
              isValid = false;
            }
          } else {
            if (value === undefined || value === true) {
              errorFlag = errorFlag || true;
              setRelationError(true);
              isValid = false;
            }
          }
        });
      }

      setError(errorFlag);
      setRelationError(true && showRelation && errorFlag);
      let missingFields = [];
      if (!isValid) {
        const isLillyManaged = LillySources.LILLY_MANAGED_SOURCES.includes(newSource);
        const addressAttributes = CONSTANT.ADDRESS_ATTRIBUTE;
        requirefields.forEach((id) => {
          let isMissing = false;
          // Skip individual address fields for non-Lilly sources - they'll be checked as a group
          if (!isLillyManaged && addressAttributes.includes(id)) {
            isMissing = false;
          } else if (id === "Relation" && !showRelation) {
            isMissing = false;
          } else if (id === "Address" && !address) {
            isMissing = false;
          } else if (
            validRequest["Relation"] === undefined ||
            validRequest["Relation"] === true
          ) {
            if (showRelation) {
              isMissing = true;
            }
          } else {
            const value = validRequest[id];
            if (value === undefined || value === true) {
              isMissing = true;
            }
          }
          if (isMissing) missingFields.push(id);
        });
        if (missingFields.length === 0) {
          const addrMissing = getMissingAddressAttributes(HCORequest?.entity?.Address);
          if (addrMissing && addrMissing.length > 0) missingFields = addrMissing;
        }
      }

      if (isValid) {
        // Clean up BRICK data if accordion is closed or BRICK ID is empty
        const isLillyManaged = LillySources.LILLY_MANAGED_SOURCES.includes(newSource);
        if (!isLillyManaged || !accordianFlag['BRICK']) {
          // Remove BRICK from address if not Lilly-managed or accordion is closed
          if (HCORequest?.entity?.Address?.[0]) {
            delete HCORequest.entity.Address[0].BRICK;
          }
        } else {
          // If accordion is open but BRICK ID is empty, remove BRICK
          const brick = HCORequest?.entity?.Address?.[0]?.BRICK?.[0];
          const idField = brick?.[CONSTANT.BRICK_FIELDS.BRICK_ID];
          const idValue = idField?.[0]?.value;
          if (!idValue || idValue.toString().trim().length === 0) {
            if (HCORequest?.entity?.Address?.[0]) {
              delete HCORequest.entity.Address[0].BRICK;
            }
          }
        }

        setModal({
          flag: true,
          message: "Comments *",
          success: true,
          title: "Submit Request",
        });
      } else {
        setModal({
          flag: true,
          success: false,
          message:
            missingFields.length > 0
              ? `Please enter values for: ${missingFields.join(', ')}`
              : popMsg[0].blankField.description,
          title: popMsg[0].blankField.heading,
        });
      }
    }
  };

  /**
   * Clear all Inputs
   */
  const clearAll = () => {
    setError(false);
    setRelationError(false);
    let CountryCode = JSON.parse(JSON.stringify(HCORequest.entity.CountryCode[0]));
    let RequestTo = HCORequest?.RequestTo;
    let vendor = HCORequest?.vendor;
    let Source = HCORequest?.entity?.Source;
    setHCORequest(CONSTANT.NEW_HCO_BODY);
    setClear(true);
    // setHCORequest((oldvalue) => ({
    //   ...oldvalue,
    //   entity: {
    //     ...oldvalue.entity,
    //     Address: [
    //       {
    //         ...oldvalue.entity.Address[0],
    //         ActiveFlag: [
    //           {
    //             value: "Y"
    //           }
    //         ]
    //       },
    //     ],
    //   }
    // }));
    // RequestTo && vendor && setHCPRequest((oldvalue) => ({
    //   ...oldvalue,
    //   RequestTo: RequestTo,
    //   vendor: vendor
    // }))

    setHCORequest((oldValue) => ({
      ...oldValue,
      entity: {
        ...oldValue.entity,
        Address: [
          {
            ...oldValue.entity.Address[0],
            ActiveFlag: [{ value: "Y" }],
          },
        ],
        Source: Source ? Source : [{ value: newSource }],
      },
      ...(RequestTo && vendor && { RequestTo, vendor }),
    }));

    updateValue(CountryCode, false, 'CountryCode');
    updateValue([], true, "Identifiers");  //clear populated identifiers
    let intervalId = setTimeout(() => {
      setClear(false);
      clearTimeout(intervalId);
    }, 1000);
  };

  /**
   * Add optional fields based on country
   *  @param {*} attribute
   */
  const addOptional = (attribute) => {
    if (attribute === "Relation") {
      setValidRequest((oldvalue) => ({ ...oldvalue, Relation: true }));
    } else if (attribute === "Speciality") {
      setValidRequest((oldvalue) => ({ ...oldvalue, Speciality: true }));
    } else {
      setValidRequest((oldvalue) => ({ ...oldvalue, Address: true }));
    }
  };

  /**
   * handle delete
   */
  const setCancel = (attribute) => {
    if (attribute === "Relation") {
      setValidRequest((oldvalue) => ({ ...oldvalue, Relation: false }));
      delete HCORequest.relations;
    } else if (attribute === "Speciality") {
      setValidRequest((oldvalue) => ({ ...oldvalue, Speciality: false }));
      delete HCORequest.entity.NewSpecialities;
    } else {
      setValidRequest((oldvalue) => ({ ...oldvalue, Address: false }));
      delete HCORequest.entity.Address;
    }
  };

  /**
   * show form based on country popup
   * @param {*} value
   */


  // const handleOk = (
  //   value,
  //   newSpecialty,
  //   allSelectedSpecialty,
  //   primarySpecialty,
  //   otherSpecialty
  // ) => {
  //   if (
  //     allSelectedSpecialty.every((res) => allSpecialty.includes(res)) &&
  //     selectedCountry == value
  //   ) {
  //     setShowModal(false);
  //   } else {
  //     setSelectedCountry(value);
  //     setPrimarySpecialty(primarySpecialty);
  //     setOtherSpecialty(otherSpecialty);
  //     let receivedResponse;
  //     let getPaylodCountry = payloadCountry.countries.find(
  //       (res) => res.country_Name === value
  //     );
  //     var getdata = data.countries.find((el) => {
  //       if (el.country_Name == value) {
  //         return el.country_Name === value;
  //       } else {
  //         return el.country_Name == "default";
  //       }
  //     });
  //     updateValue({ value }, false, "CountryCode");
  //     setSelectedSpecialty(newSpecialty);
  //     setAllspecialty(allSelectedSpecialty);
  //     setLoading(true);

  //     api
  //       .getPickList(
  //         getPaylodCountry ? getPaylodCountry.key.payloadKey : value,
  //         null,
  //         allSelectedSpecialty,
  //         "HCO"
  //       )
  //       .then((res) => {
  //         Storage.setLovBoundedList(filter.mapPickList(res.data[0]));
  //         setNewSource(res.data[0]["source"][0]);
  //         setOriginalSource(
  //           res.data[0]["source"][0] == "MNGD-AFF" && newSource == "MNGD-AFF"
  //             ? ""
  //             : originalSource
  //         );
  //         receivedResponse = res.data[0]["source"][0];
  //         setfilterdata(
  //           res.data[0]["source"][0] == "VNDR-CGDM"
  //             ? getdata.input.iqvia
  //             : getdata.input.eph
  //         );
  //         setLoading(false);
  //         setShowModal(false);
  //         setShowAllData(true);
  //       })
  //       .catch((error) => {
  //         let errorDetail = error;
  //         let msg = errorDetail.response
  //           ? errorDetail.response.data.errorCode
  //           : "Internal Server Error!";
  //         setErrorMsg(msg ? msg : "Internal Server Error!");
  //         setLoading(false);
  //       });

  //     if (receivedResponse == "VNDR-CGDM") {
  //       setHCORequest({
  //         entity: {
  //           type: "configuration/entityTypes/HCO",
  //           ActiveFlag: [{ value: "Y" }],
  //           EffectiveStartDate: [
  //             { value: moment.utc(new Date()).format("YYYY-MM-DD") },
  //           ],
  //           EffectiveEndDate: [{ value: "9999-12-31" }],
  //           NewSpecialities: newSpecialty,
  //           NewIdentifiers: [],
  //           Address: [
  //             {
  //               Country: [
  //                 {
  //                   value: selectedCountry,
  //                 },
  //               ],
  //               ActiveFlag:[
  //                 {
  //                     value: "Y"
  //                 }
  //             ]
  //             },
  //           ],
  //           Source: [{ value: receivedResponse }],
  //         },
  //         relations: [],
  //         RequestTo: "IQVIA",
  //         vendor: "IQVIA",
  //       });
  //     } else {
  //       setHCORequest({
  //         entity: {
  //           type: "configuration/entityTypes/HCO",
  //           ActiveFlag: [{ value: "Y" }],
  //           EffectiveStartDate: [
  //             { value: moment.utc(new Date()).format("YYYY-MM-DD") },
  //           ],
  //           EffectiveEndDate: [{ value: "9999-12-31" }],
  //           NewSpecialities: newSpecialty,
  //           NewIdentifiers: [],
  //           Address: [
  //             {
  //               Country: [
  //                 {
  //                   value: selectedCountry,
  //                 },
  //               ],
  //               ActiveFlag:[
  //                 {
  //                     value: "Y"
  //                 }
  //             ]
  //             },
  //           ],
  //           Source: [{ value: receivedResponse }],
  //         },
  //         relations: [],
  //       });
  //     }
  //   }
  // };
  /**
   * change source and form fields
   * @param {*}
   */

  const changeSourceAndFields = () => {
    setLoading(true);
    api
      .getPickList(
        selectedCountry,
        originalSource == 'VNDR-VOD' && newSource == 'MNGD-AFF'
          ? originalSource
          : LillySources.SOURCE_OVERRIDED[0][newSource],
        undefined,
        "HCO",
      )
      .then((res) => {
        Storage.setLovBoundedList(filter.mapPickList(res.data[0]));
        setNewSource(res.data[0]["source"][0]);
        countryDataFetch(res.data[0]["source"][0]);
        setLoading(false);
        setShowAllData(true);
        if (
          (res.data[0]["HCO"] && res.data[0]["HCO"]?.spclty != undefined && res.data[0]["HCO"]?.spclty?.length > 0) ||
          (res.data[0]["UNCLASSIFIED"] && res.data[0]["UNCLASSIFIED"]?.spclty != undefined && res.data[0]["UNCLASSIFIED"]?.spclty?.length > 0)
        ) {
          setShowSpecialityAccordian(true);
        } else {
          setShowSpecialityAccordian(false);
        }
      })
      .catch((error) => {
        let errorDetail = error;
        let msg = errorDetail.response
          ? errorDetail.response.data.errorCode
          : "Internal Server Error!";
        setErrorMsg(msg ? msg : "Internal Server Error!");
        setLoading(false);
      });
  };

  // function to close specialty popup
  const closePopup = () => {
    if (showModal) {
      setShowModal(false);
    } else {
      setCloseSpecialtyPopup(false);
    }
  };

  return (
    <div className="body-height">
      {loading && (
        <div className="extra-margin-top d-flex justify-content-center body-height">
          <ProgressBar />
        </div>
      )}
      {closeSpecialtyPopup && !loading && (
        <ConfirmationDialogRaw1
          open={closeSpecialtyPopup}
          option={allCountry}
          selectedCountry={location.state.country}
          entityType='HCO'
          entity="HCO"
          onOk={closePopup}
          onCancel={closePopup}
          user={props.user}
        />
      )}
      {!loading && errorMsg === undefined && showAllData && (
        <div className="extra-margin-top-less container w-80 body-height min-width">
          <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            gap={1}
          >
            <Tooltip disableFocusListener title="Back" id="tltipStrictSearchChckbx">
              <IconButton
                aria-label="delete"
                onClick={goBack}
                className="text-danger float-end"
                color="secondary"
              >
                <ArrowBackIcon
                  sx={{ transform: direction === "rtl" ? "rotate(180deg)" : "" }}
                />
              </IconButton>
            </Tooltip>
            <Typography variant="h1" margin={0} style={{ fontSize: 21 }} id="newhcp-text">
              HCO Details
            </Typography>
          </Stack>

          {!iqviaEnnable && (
            <>
              <Card className="p-0 mb-3 mt-2">
                <IconButton
                  aria-label="delete"
                  onClick={editCountry}
                  sx={{ float: "right", marginLeft: "30px" }}
                >
                  <Tooltip disableFocusListener title="Edit details   " id="tooltip">
                    <EditIcon
                      sx={{ transform: direction === "rtl" ? "rotate(180deg)" : "" }}
                    />
                  </Tooltip>
                </IconButton>
                <CardContent className="p-2">
                  <Stack
                    direction="row"
                    justifyContent={"space-around"}
                    alignItems="center"
                    flexWrap={"wrap"}
                    className="p-0 m-0"
                  >
                    <Typography variant="p" margin={0} id="newhcp-text">
                      <span className="text-muted">Country: </span>
                      <span className="_wg-exclude">
                        {location.state.country ? location.state.country : selectedCountry}{" "}
                      </span>
                    </Typography>
                    <Typography variant="p" margin={0} id="newhcp-text">
                      <span className="text-muted">Source: </span>
                      <span className="_wg-exclude">{newSource}</span>
                    </Typography>
                  </Stack>
                </CardContent>
              </Card>
              {userData?.dcrSourceOverride &&
                (!LillySources.LILLY_MANAGED_SOURCES.includes(newSource) || originalSource != "MNGD-AFF") &&
                data.allow_override_dcr && (
                  <Alert
                    icon={<AltRouteIcon fontSize="inherit" />}
                    action={
                      <Button
                        color="error"
                        size="small"
                        variant="contained"
                        className="routeButtonContain"
                        onClick={() => changeSourceAndFields()}
                      >
                        Yes
                      </Button>
                    }
                    className="mb-3"
                    severity="warning"
                  >
                    {!LillySources.LILLY_MANAGED_SOURCES.includes(newSource) && (
                      <>
                        {popMsg[0].sourceOverride["description"]
                          .replace(/{{source}}/g, originalSource)
                          .replace(/{{source1}}/g, LillySources.SOURCE_OVERRIDED[0][newSource])}
                      </>
                    )}
                    {originalSource != "MNGD-AFF" && newSource == "MNGD-AFF" && (
                      <>
                        {popMsg[0].sourceOverride["description-1"]
                          .replace(/{{source}}/g, newSource)
                          .replace(/{{source1}}/g, originalSource)}
                      </>
                    )}
                  </Alert>
                )}
            </>
          )}

          <div>
            {filterdata.map((el, index) => {
              return (
                (!iqviaEnnable ? el.id != 'speciality' : el.id != 'Address') && el.id !== 'BRICK' && (
                  <Accordion key={index} className=" shadow-md" expanded={accordianFlag[el.id]}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id={el.id}
                      onClick={() => closeAccordian(el.id)}
                    >
                      <Typography id="newhcp-text" className="form-headingBold" fontWeight="bold">
                        {el.heading}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div className=" row container w-100 p-3 pt-0">
                        {el.attributes
                          .filter(value => !value.brick)
                          .sort((a, b) => a.order - b.order)
                          .map((value, key) => {
                            if (value.required && (el.id !== "Address" && value.id !== "ClassificationCode")) {
                              requirefields.push(value.id);
                            }

                            return (
                              (el.id === "Address" && value.id === "ClassificationCode") ? null :
                                value.active === true && (
                                  <div key={key} className="col-sm-12 col-md-6">
                                    <span id="newhcp-text">{value.name}</span>
                                    {value.required && (
                                      <span className="required-asterisk-exclusion"> *</span>
                                    )}
                                    <InputDetailsHCO
                                      clear={clear}
                                      date={value.date === true}
                                      newHCO={true}
                                      newValue={filterdata}
                                      require={value.required}
                                      error={error}
                                      sourceName={HCORequest?.entity?.Source?.[0]?.value}
                                      countryName={location.state.country || selectedCountry}
                                      type={value.type}
                                      value={
                                        value.id === "Country"
                                          ? selectedCountry
                                          : (HCORequest.entity.Address?.[0]?.[value.id]?.[0]?.value || "")
                                      }
                                      isCountryDisabled={value.id === "Country" ? true : false}
                                      label={value.name}
                                      updatedValue={(newValue, flag) => {
                                        const brickAttrMap = {
                                          BrickId: CONSTANT.BRICK_FIELDS.BRICK_ID,
                                          BrickEffectiveEndDate: CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_END_DATE,
                                          BrickEffectiveStartDate: CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_START_DATE,
                                          BrickType: CONSTANT.BRICK_FIELDS.BRICK_TYPE,
                                          BrickSource: CONSTANT.BRICK_FIELDS.BRICK_SOURCE,
                                        };
                                        const attr = brickAttrMap[value.id] || value.id;
                                        updateValue(newValue, flag, attr);
                                        setValidRequest((old) => ({ ...(old || {}), [value.id]: flag }));
                                      }}
                                    />
                                  </div>
                                )
                            );
                          })}
                      </div>

                      {el.id === "Address" && CONSTANT.BRICK_LILLY_MANAGED_SOURCES.includes(HCORequest.entity.Source?.[0]?.value) && (
                        (() => {
                          let brickSection = null;
                          try {
                            if (data?.countries && Array.isArray(data.countries)) {
                              const countryName = location.state?.country || selectedCountry;
                              const country = data.countries.find(c => c?.country_Name === countryName)
                                           || data.countries.find(c => c?.country_Name === 'default');
                              if (country?.input) {
                                const source = HCORequest.entity.Source?.[0]?.value;
                                const vendor = source === "VNDR-CGDM" ? 'iqvia' : (source === "VNDR-VOD" ? 'openData' : 'eph');
                                const sections = country.input[vendor];
                                if (Array.isArray(sections)) {
                                  brickSection = sections.find(s => s?.id === 'BRICK');
                                }
                              }
                            }
                          } catch (e) {
                            console.error('Error finding BRICK section:', e);
                          }
                          if (!brickSection) return null;
                          return (
                            <div className="row container w-100 p-0">
                              <div className="col-12">
                                <div
                                  className="d-flex justify-content-between align-items-center"
                                  style={{ padding: '12px 0 4px 0', cursor: 'pointer' }}
                                  onClick={() => closeAccordian("BRICK")}
                                >
                                  <Typography variant='subtitle1' className='fw-bold _wg-dynamic-text'>{brickSection.heading}</Typography>
                                  <ExpandMoreIcon
                                    style={{
                                      transform: accordianFlag['BRICK'] ? 'rotate(180deg)' : 'rotate(0)',
                                      transition: 'transform .2s',
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-12">
                                <div style={{ display: accordianFlag["BRICK"] ? "block" : "none" }}>
                                  <div className="row w-100 p-3 pt-0">
                                    {brickSection.attributes.map((value, key) => {
                                      const brickObj = HCORequest.entity.Address?.[0]?.BRICK?.[0];
                                      const brickFieldKeyMap = {
                                        BrickType:               { key: CONSTANT.BRICK_FIELDS.BRICK_TYPE,                 field: 'lookupRawValue', fallback: 'value' },
                                        BrickId:                 { key: CONSTANT.BRICK_FIELDS.BRICK_ID,                   field: 'value' },
                                        BrickEffectiveStartDate: { key: CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_START_DATE, field: 'value' },
                                        BrickEffectiveEndDate:   { key: CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_END_DATE,   field: 'value' },
                                        BrickSource:             { key: CONSTANT.BRICK_FIELDS.BRICK_SOURCE,               field: 'value' },
                                      };
                                      const brickFieldDef = brickFieldKeyMap[value.id];
                                      const brickEntry = brickFieldDef ? brickObj?.[brickFieldDef.key]?.[0] : null;
                                      const defaultBrickEntry = brickFieldDef
                                        ? (lillyManagedBrickDefaults.BRICK?.[0]?.[brickFieldDef.key]?.[0])
                                        : null;
                                      const brickDisplayValue = (brickEntry || defaultBrickEntry)
                                        ? (
                                            (brickEntry ? brickEntry[brickFieldDef.field] : defaultBrickEntry[brickFieldDef.field]) ||
                                            (brickEntry ? brickEntry[brickFieldDef.fallback] : defaultBrickEntry[brickFieldDef.fallback]) ||
                                            ''
                                          )
                                        : '';

                                      return (
                                        <div key={key} className="col-6">
                                          <span id="newhcp-text">{value.name}</span>
                                          {value.required && (
                                            <span className="required-asterisk-exclusion"> *</span>
                                          )}
                                          {value.readOnly === true ? (
                                            <div className="w-100">
                                              <span
                                                className="text-muted _wg-exclude"
                                                style={{
                                                  display: 'block',
                                                  padding: '6px 0 7px',
                                                  borderBottom: '1px solid rgba(0,0,0,0.42)',
                                                  minHeight: '32px',
                                                }}
                                              >
                                                {brickDisplayValue}
                                              </span>
                                              <div style={{ height: '23px' }} />
                                            </div>
                                          ) : (
                                            <InputDetailsHCO
                                              clear={clear}
                                              date={value.type === 'date'}
                                              newHCO={true}
                                              newValue={filterdata}
                                              require={value.required}
                                              error={error}
                                              sourceName={HCORequest?.entity?.Source?.[0]?.value}
                                              countryName={location.state.country || selectedCountry}
                                              type={value.type}
                                              value={brickDisplayValue}
                                              label={value.name}
                                              updatedValue={(newValue, flag) => {
                                                const brickAttrMap = {
                                                  BrickId:                 CONSTANT.BRICK_FIELDS.BRICK_ID,
                                                  BrickEffectiveEndDate:   CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_END_DATE,
                                                  BrickEffectiveStartDate: CONSTANT.BRICK_FIELDS.BRICK_EFFECTIVE_START_DATE,
                                                  BrickType:               CONSTANT.BRICK_FIELDS.BRICK_TYPE,
                                                  BrickSource:             CONSTANT.BRICK_FIELDS.BRICK_SOURCE,
                                                };
                                                const attr = brickAttrMap[value.id] || value.id;
                                                updateValue(newValue, flag, attr);
                                                setValidRequest((old) => ({ ...(old || {}), [value.id]: flag }));
                                              }}
                                            />
                                          )}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })()
                      )}
                    </AccordionDetails>
                  </Accordion>
                )
              );
            })}

            <IdentifiersView
              addFlag={"HCO"}
              mode={"Edit"}
              entity={'HCO'}
              change={changeCompleted}
              error={showError}
              label={"Identifier"}
              updatedValue={(newValue, flag) => {
                updateValue(newValue, flag, "Identifiers");
              }}
              heading={"Type&ID"}
              value={HCORequest.entity.NewIdentifiers}
              checkIdentifierSubmitted={(addflag, identifierType, identifierId, identifierSaved) => {
                checkIdentifierSubmitted(addflag, identifierType, identifierId, identifierSaved);
              }}
              submit={identifierSubmit}
              shadow={true}
              vendor={location.state.vendor}
            />
          </div>

          {/* Accordion for speciality */}
          <>
            {showSpecialityAccordian && (
              <Accordion square className={`shadow-md mt-2 col-12`} expanded={accordianFlag["speciality"]}>
                <AccordionSummary
                  onClick={() => closeAccordian("speciality")}
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="IdentifiersView_AccordionSummary"
                  className='bg-grey'
                >
                  <Typography variant='subtitle1' className='fw-bold _wg-dynamic-text'>Speciality</Typography>
                </AccordionSummary>
                <AccordionDetails className=''>
                  {!showSpeciality && (
                    <div className=" container w-100 p-3 pt-0">
                      <Stack direction='row' alignItems='center'>
                        <IconButton
                          size='small'
                          sx={{ backgroundColor: 'var(--lilly-primary)', '&:hover': { background: 'var(--lilly-primary)', opacity: '0.6' } }}
                          onClick={() => {
                            setShowSpeciality(true);
                            addOptional("Speciality");
                          }}
                        >
                          <Add sx={{ color: 'white' }} />
                        </IconButton>
                        <Typography marginLeft='10px' className='_wg-dynamic-text' variant='subtitle1'>
                          Add Specialities
                        </Typography>
                      </Stack>
                    </div>
                  )}

                  {showSpeciality && (
                    <div className=" row container w-100 p-3 pt-0">
                      {jsondata.Specialities.attributes
                        .sort((a, b) => a.order - b.order)
                        .map((value, key) => {
                          if (value.id === "OtherSpecialty" && newSource !== 'MNGD-AFF') {
                            return null;
                          } else {
                            return (
                              value.active === true && (
                                <div key={key} className="col-sm-12 col-md-6">
                                  <span id="newhcp-text">{value.name}</span>
                                  {value.required && (
                                    <span className="required-asterisk-exclusion"> *</span>
                                  )}
                                  <InputDetailsHCO
                                    clear={clear}
                                    date={false}
                                    newHCO={true}
                                    source={newSource}
                                    newValue={filterdata}
                                    require={value.required}
                                    error={error}
                                    type={value.type}
                                    value={value.id === "Country" ? selectedCountry : ""}
                                    isCountryDisabled={value.id === "Country" ? true : false}
                                    label={value.name}
                                    updatedValue={(newValue, flag) => {
                                      updateValue(newValue, flag, value.id);
                                    }}
                                  />
                                </div>
                              )
                            );
                          }
                        })}
                    </div>
                  )}

                  {showSpeciality && (
                    <Stack direction={"row"} justifyContent={"flex-end"}>
                      <Button
                        sx={{ color: "gray", "&:hover": { background: "rgba(134,136,138,0.05)" } }}
                        size="small"
                        onClick={() => {
                          setShowSpeciality(false);
                          setCancel("Speciality");
                        }}
                      >
                        Cancel
                      </Button>
                    </Stack>
                  )}
                </AccordionDetails>
              </Accordion>
            )}
          </>

          {/* Accordion for adding relation */}
          <>
            <Accordion className="shadow-md" expanded={accordianFlag["Relation"]}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="FirstName"
                onClick={() => closeAccordian("Relation")}
              >
                <Typography id="newhcp-text" fontWeight="bold">Relation</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {optionalRelation === "Optional" && !showRelation && (
                  <div className=" container w-100 p-3 pt-0">
                    <Stack direction='row' alignItems='center'>
                      <IconButton
                        size='small'
                        sx={{ backgroundColor: 'var(--lilly-primary)', '&:hover': { background: 'var(--lilly-primary)', opacity: '0.6' } }}
                        onClick={() => {
                          setShowRelation(true);
                          addOptional("Relation");
                        }}
                      >
                        <Add sx={{ color: 'white' }} />
                      </IconButton>
                      <Typography marginLeft='10px' className='_wg-dynamic-text' variant='subtitle1'>
                        Add Relation
                      </Typography>
                    </Stack>
                  </div>
                )}

                {showRelation && !iqviaEnnable && (
                  <div className="w-100">
                    <NewRelation
                      clear={clear}
                      country={HCORequest.entity.CountryCode[0].value}
                      source={HCORequest?.entity?.Source?.[0]?.value}
                      newHCP={true}
                      newData={filterdata}
                      error={relationError}
                      AddNewRelation={(newValue, flag) => {
                        updateValue(newValue, flag, "Relation");
                      }}
                      iqviaEnnable={iqviaEnnable}
                      searchHCOPayload={
                        data.search_hco_payload.country_config[HCORequest.entity.CountryCode[0].value]
                          ? data.search_hco_payload.country_config[HCORequest.entity.CountryCode[0].value]
                          : data.search_hco_payload.country_config['Default']
                      }
                      hcoQuery={data.search_hco_payload}
                      entity={"HCO"}
                      isVendor={newSource !== "MNGD-AFF" ? true : false}
                    />
                  </div>
                )}

                {optionalRelation === "Optional" && showRelation && (
                  <Stack direction={"row"} justifyContent={"flex-end"}>
                    <Button
                      sx={{ color: "gray", "&:hover": { background: "rgba(134,136,138,0.05)" } }}
                      size="small"
                      onClick={() => {
                        setShowRelation(false);
                        setCancel("Relation");
                      }}
                    >
                      Cancel
                    </Button>
                  </Stack>
                )}
              </AccordionDetails>
            </Accordion>
          </>

          <>
            <DialogActions
              className="d-flex justify-content-center mt-4 mb-3"
              id="newhcp-button"
              sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
            >
              <Button
                className="btn btn-secondry border clearall"
                onClick={() => { clearAll(); }}
                color="error"
                variant="outlined"
              >
                CLEAR ALL
              </Button>
              <Button
                className="btn btn-secondry border request"
                onClick={() => { submitRequest(); }}
                color="error"
                variant="contained"
              >
                REQUEST
              </Button>
            </DialogActions>
          </>

          {modal.flag && (
            <PopupConfimation
              updateDetails={{...HCORequest, entity: {...HCORequest.entity, ...(LillySources.LILLY_MANAGED_SOURCES.includes(newSource) ? {IsNew: true} : {})}}}
              closePopup={() => { setModal(false); }}
              open={modal.flag}
              success={modal.success}
              message={modal.message}
              title={modal.title}
              typeHCO={true}
              addNewHCO={true}
              flag={modal.flag}
              close={() => {
                setModal(false);
                goBack();
              }}
              source={newSource}
              isHcoWithoutRelation={HCORequest?.relation ? false : true}
            />
          )}
        </div>
      )}

      {errorMsg !== undefined && <ErrorPage message={errorMsg} />}
    </div>
  );
};

export default withRouter(AddNewHCO);
